import { render, staticRenderFns } from "./dialog-site-assignment.vue?vue&type=template&id=084c2f32&scoped=true"
import script from "./dialog-site-assignment.vue?vue&type=script&lang=js"
export * from "./dialog-site-assignment.vue?vue&type=script&lang=js"
import style0 from "./dialog-site-assignment.vue?vue&type=style&index=0&id=084c2f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c2f32",
  null
  
)

export default component.exports